import { jsx } from 'react/jsx-runtime';
import { memo } from 'react';

/**
 * `ApplyHomography` is a React component that applies a homography transformation to its children elements.
 *  It's primarily used for adjusting the position and orientation of elements based on a given homography matrix.
 *  The x and y coordinates are unchanged, meaning homography is applied to the children without effecting their
 *  position in video space.
 */
function ApplyHomography({ x, y, h, children }) {
    const style = {
        transform: `matrix(${h[0][0]}, ${h[1][0]}, ${h[0][1]}, ${h[1][1]}, ${x}, ${y})`,
    };
    return jsx("g", { style: style, children: children });
}
memo(ApplyHomography);

export { ApplyHomography };
//# sourceMappingURL=ApplyHomography.js.map
